import request from "./request";

/**获取单一活动详情 
 * @param {Number} uid
 * @param {String} usertoken
 * @param {Number} aid
 * 
*/
export async function getchoujianginfo() {
  return await request.get("/wxindex/choujiang/getactive.html")
}

/**立即抽奖
 * @param {Object} postInfo
 * uid,usertoken,code
 */
export async function choujiang(postInfo) {
  return await request.post(`/wxindex/choujiang/select.html`, postInfo)
}

/**获取中奖记录
 * @param {Object} log
 * uid,usertoken,code
 */
export async function getlog(log) {
  return await request.post(`/wxindex/choujiang/getlog.html`, log)
}

/**获取全部中将记录 */
export async function getlogall(log) {
  return await request.post(`/wxindex/choujiang/getlogall.html`, log)
}
